import pencil from "../../../../pages/Viewer/Images/pencil.svg";
import erase from "../../../../pages/Viewer/Images/eraser.svg";
import trash from "../../../../pages/Viewer/Images/trash.svg";
import circleIcon from "../../../../pages/Viewer/Images/Circle.svg";
import closeImg from "../../../../pages/Viewer/Images/close.svg";
import { Modal } from "antd";
import "./styles.scss";

const DrawingOptions = (props: any) => {
    const {
        showDominantSpeaker,
        showMultiStreamViewer,
        onDrawingClick,
        showDrawingOption,
        pencilToggled,
        isPencilLine,
        circleToggled,
        isPencilCircle,
        isEraser,
        eraserToggled,
        clearWhiteBoardAll,
        enablePencilIcon,
        enableEraserIcon,
        closeImg: closeImgProp,
        useOverlayForDrawingTools,
    } = props;

    if (showMultiStreamViewer) {
        return <></>
    }

    const closeIcon = closeImgProp || closeImg;
    const isAnyDrawingToolActive = isPencilLine || isPencilCircle || isEraser;

    const renderInline = !useOverlayForDrawingTools || !showDrawingOption;

    const drawingToolsButtons = (
        <>
            <div
                className={`drawing-tool-button ${isPencilLine ? 'active' : ''}`}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!showDominantSpeaker && pencilToggled) pencilToggled();
                }}
            >
                <img src={pencil} alt="Pencil" />
                <span>Pencil</span>
            </div>
            <div
                className={`drawing-tool-button ${isPencilCircle ? 'active' : ''}`}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!showDominantSpeaker && circleToggled) circleToggled();
                }}
            >
                <img src={circleIcon} alt="Circle" />
                <span>Circle</span>
            </div>
            <div
                className={`drawing-tool-button ${isEraser ? 'active' : ''}`}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!showDominantSpeaker && eraserToggled) eraserToggled();
                }}
            >
                <img src={erase} alt="Erase" />
                <span>Erase</span>
            </div>
            <div
                className="drawing-tool-button"
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!showDominantSpeaker && clearWhiteBoardAll) clearWhiteBoardAll();
                }}
            >
                <img src={trash} alt="Clear" />
                <span>Clear</span>
            </div>
        </>
    );

    return (
        <>
            <div
                className={`top-menu-button-item cameraMenu pencil-tool-dropdown-x ${enablePencilIcon ? "canvas-pencil-on" : ""} ${showDrawingOption || isAnyDrawingToolActive ? "annotation-active" : ""}`}
                onClick={onDrawingClick}
                style={{ cursor: 'pointer', position: 'relative' }}
            >
                <img src={showDrawingOption ? closeIcon : pencil} alt="" />
                {!showDrawingOption && <span>Annotation</span>}

                {showDrawingOption && renderInline && (
                    <div
                        className={`drawing-tools-container ${showDominantSpeaker ? "disableddiv" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            zIndex: 1001,
                            marginTop: '8px',
                        }}
                    >
                        {drawingToolsButtons}
                    </div>
                )}
            </div>

            {useOverlayForDrawingTools && (
                <Modal
                    open={showDrawingOption}
                    onCancel={onDrawingClick}
                    footer={null}
                    title={null}
                    closable={false}
                    maskClosable={true}
                    width={Math.min(320, typeof window !== 'undefined' ? window.innerWidth - 32 : 320)}
                    className="drawing-options-modal"
                    wrapClassName="drawing-options-modal-wrap"
                    getContainer={() => document.body}
                >
                    <div className={`drawing-tools-container drawing-tools-modal-body ${showDominantSpeaker ? "disableddiv" : ""}`}>
                        {drawingToolsButtons}
                    </div>
                </Modal>
            )}
        </>
    );
};

export default DrawingOptions;